import React from 'react';
import { useIntl } from 'react-intl';
import { Alert } from 'reactstrap';
import { TypedMemo } from '../../../../common/types';
import { reelMessages } from './reelMessages';

/** Design a6: a 503 `AI_REELS_UNAVAILABLE`. No video credit was used; the form keeps its values. */
const ReelUnavailableAlertComponent: React.FC = () => {
  const intl = useIntl();

  return (
    <Alert color="danger" className="mb-0" role="alert">
      <strong>{intl.formatMessage(reelMessages.unavailableTitle)}</strong>
      <br />
      {intl.formatMessage(reelMessages.unavailableBody)}
    </Alert>
  );
};

export const ReelUnavailableAlert = TypedMemo(ReelUnavailableAlertComponent);
